(function () {
  var SECTION_SELECTOR = '.oddit-section-scrolling-text';
  var SET_SELECTOR = '.oddit-section-scrolling-text__marquee-set';
  var DEFAULT_PX_PER_SECOND = 60;
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    if (!track) return null;
    var baseSet = track.querySelector('[data-marquee-set]');
    if (!baseSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var setWidth = baseSet.scrollWidth;
      var viewportWidth = section.clientWidth;
      if (setWidth <= 0) return;

      var needed = Math.max(2, Math.ceil(viewportWidth / setWidth) + 1);
      var current = track.querySelectorAll(SET_SELECTOR).length;

      while (current < needed) {
        var clone = baseSet.cloneNode(true);
        clone.removeAttribute('data-marquee-set');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        current++;
      }

      var unit = setWidth + trackGap;
      var speed = parseFloat(section.dataset.scrollSpeed);
      if (!speed || speed <= 0) speed = DEFAULT_PX_PER_SECOND;
      track.style.setProperty('--marquee-distance', '-' + unit + 'px');
      track.style.setProperty('--marquee-duration', (unit / speed) + 's');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function handleReducedMotion(e) {
      if (e.matches) disable();
      else enable();
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleReducedMotion);
    }

    function handleVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    document.addEventListener('visibilitychange', handleVisibility);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!reducedMotion.matches) measure();
      });
    }

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      handleReducedMotion: handleReducedMotion,
      handleVisibility: handleVisibility
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.reducedMotion.removeEventListener) {
      state.reducedMotion.removeEventListener('change', state.handleReducedMotion);
    }
    document.removeEventListener('visibilitychange', state.handleVisibility);
  }

  function initSection(section) {
    if (!section) return;
    var key = section.id || section;
    if (sectionState.has(key)) return;
    var state = { marquee: initMarquee(section) };
    sectionState.set(key, state);
  }

  function destroySection(section) {
    if (!section) return;
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(key);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
